import { type ReactNode } from 'react';
import type { Creator } from '@/types';
import { useAlertCreator } from '../hooks/use-creator-alert';
import { CreatorAlertConfirm } from './creator-alert-confirm';
import type { DetailMode } from './creator-detail-sections';

type Props = {
  creator: Creator;
  setMode: (m: DetailMode) => void;
  onClose: () => void;
};

export function AlertSection({ creator, setMode, onClose }: Props): ReactNode {
  const alert = useAlertCreator();
  return (
    <div className="mt-base">
      <CreatorAlertConfirm
        onConfirm={() => alert.mutate(creator.id, { onSuccess: onClose })}
        onCancel={() => setMode('view')}
        isPending={alert.isPending}
      />
    </div>
  );
}
